class ValidationHelper {
    isNullOrEmpty (value) {
        return !value || value.trim().length === 0;
    }

    isValidIdentifier (value) {
        return value && value.toString().length > 0 && value> 0;
    }

    exceedsMaxLength (value, maxLength) {
        return !value || value.trim().length > maxLength;
    }

    isValidEmailFormat (value) {
        // eslint-disable-next-line no-useless-escape
        var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(value);
    }

    isDigitsOnly(value){
        // eslint-disable-next-line no-useless-escape
        const regex = /^[0-9]*$/;
        return regex.test(value);
    }

    isValidName (value) {
        // Starts end ends with literal. Can contain ".", "-", "'" and space. Can be one character.
        // eslint-disable-next-line no-useless-escape
        var regex = /(^[a-zA-Z]+[a-zA-Z\s.'\-]*[a-zA-Z]+$)|(^[a-zA-Z]$)/;
        return regex.test(value);
    }

    isValidUserName (value) {
        // Starts end ends with literal. Can contain ".", "-", "'" and space. Can be one character.
        // eslint-disable-next-line no-useless-escape
        var regex = /(^[a-zA-Z]+[a-zA-Z\s.'-]*[a-zA-Z.'-]+$)|(^[a-zA-Z]$)/;
        return regex.test(value);
    }

    createValidationResult (isValid, error) {
        return { isValid: isValid, error: error };
    }

    isValidPhoneNumber (value) {
        // Starts end ends with literal. Can contain ".", "-", "'" and space. Can be one character.
        // eslint-disable-next-line no-useless-escape
        var re = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
        return re.test(value);
    }
}

export default new ValidationHelper();

